import { render, staticRenderFns } from "./left-sidebar.vue?vue&type=template&id=b72a1780&"
import script from "./left-sidebar.vue?vue&type=script&lang=js&"
export * from "./left-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports